import axios from "axios"

export const  saveOrUpdateCustomizeFormAPI = (obj) =>{
  return   axios.post(`/pmdm/changes/saveOrUpdateCustomizeForm`,obj)
}


export const  deleteCustomizeFormAPI = (obj) =>{
  return   axios.post(`/pmdm/changes/deleteCustomizeForm`,obj)
}